import { useRef } from 'react';

// Lightweight touch-swipe detector for image galleries. Spread the returned
// handlers onto the swipeable element. Horizontal swipes past the threshold
// fire onSwipeLeft / onSwipeRight; mostly-vertical gestures are ignored so
// page scrolling still works.
export function useSwipe({ onSwipeLeft, onSwipeRight, threshold = 40 } = {}) {
  const start = useRef(null);

  const onTouchStart = (e) => {
    const t = e.touches?.[0];
    if (!t) return;
    start.current = { x: t.clientX, y: t.clientY };
  };

  const onTouchEnd = (e) => {
    if (!start.current) return;
    const t = e.changedTouches?.[0];
    if (!t) { start.current = null; return; }
    const dx = t.clientX - start.current.x;
    const dy = t.clientY - start.current.y;
    start.current = null;
    if (Math.abs(dx) < threshold || Math.abs(dx) < Math.abs(dy)) return;
    if (dx < 0) onSwipeLeft?.();
    else onSwipeRight?.();
  };

  return { onTouchStart, onTouchEnd };
}

export default useSwipe;
